<template>
  <nav class="nav-top_ntp" :class="{ [curTheme]: true }">
    <div class="attention-test">
      Внимание! Платформа работает в тестовом режиме
    </div>
    <div class="ntp_container">

      <router-link
        to="/"
        class="ntp_logo_lgo"
        @mouseover.native="animateLogo">
        <span class="lgo_symbol"></span>
        <span class="lgo_text"></span>
      </router-link>

      <div class="menu_ntm">

        <template v-if="showThemeSelector">
          <theme-selector/>
          <div class="ntm_divider"></div>
        </template>

        <router-link
          to="/objects/add"
          class="ntm_icon ntm_icon--depo"/>

        <div class="ntm_divider"></div>

        <el-dropdown
            :hide-on-click="true"
            class="ntm_dropdown"
            trigger="hover">

          <span class="el-dropdown-link">
            <button class="ntm_link">О проекте</button>
          </span>

          <el-dropdown-menu slot="dropdown">

            <el-dropdown-item>
              <router-link to="/about-project">
                О проекте
              </router-link>
            </el-dropdown-item>

            <el-dropdown-item>
              <router-link to="/about-ois">
                Цифровые объекты авторского права (ЦОАП)
              </router-link>
            </el-dropdown-item>

            <el-dropdown-item>
              <router-link to="/help/1">
                Справочная информация
              </router-link>
            </el-dropdown-item>

            <el-dropdown-item>
              <router-link to="/about-team">
                Команда проекта
              </router-link>
            </el-dropdown-item>

            <el-dropdown-item>
              <router-link to="/about-organizations">
                Вузы-участники проекта
              </router-link>
            </el-dropdown-item>

            <el-dropdown-item>
              <router-link to="/about-experts">
                Эксперты
              </router-link>
            </el-dropdown-item>

            <!--<el-dropdown-item command="/about-mentors">
              Менторы</el-dropdown-item>-->

          </el-dropdown-menu>

        </el-dropdown>

        <div class="ntm_divider"></div>

        <button
          class="ntm_icon ntm_icon--user"
          :class="{ 'ntm_icon--user-fio': isAuthenticated }"
          @click="userIconClicked">
          <template v-if="userData">{{ userFio }}</template>
        </button>

        <template v-if="isAuthenticated">
          <button
            class="ntm_icon ntm_icon--user_stat"
            @click="userStatClicked">
            <template
              v-if="userGameStatus.userScore !== null && userGameStatus.userReputation !== null">
              <div class='user-score'>
                {{ userGameStatus.userScore }}
                <sup v-if="userScoreTrend"
                  :class="userScoreTrend > 0 ? 'trend-pos' : 'trend-neg'"
                  class='user-stat-trend'>
                  {{ userScoreTrend > 0 ? '&uarr;' : '&darr;' }} {{ userScoreTrend }}
                </sup>
              </div>
              <div class='user-reputation'>
                {{ userGameStatus.userReputation }}
                <sup v-if="userReputationTrend"
                  :class="userReputationTrend > 0 ? 'trend-pos' : 'trend-neg'"
                  class='user-stat-trend'>
                    {{ userReputationTrend > 0 ? '&uarr;' : '&darr;' }} {{ userReputationTrend }}
                </sup>
              </div>
            </template>
          </button>
          <div class="ntm_divider"></div>
          <button
            class="ntm_icon ntm_icon--exit"
            @click="$store.dispatch('user/logout')"/>
        </template>

        <div class="ntm_divider"></div>

        <button
          class="ntm_icon ntm_icon--tour"
          @click="$store.commit('setTourState', 1)"/>

      </div>

      <div class="ntp_menu-mobile_mme">

        <el-menu
          class="mme_menu"
          ref="mobileMenu"
          @select="mobileMenuHandler"
          mode="vertical">

          <el-submenu index="1">

            <template slot="title">
              <button class="mme_trigger"></button>
            </template>

            <el-menu-item
              index="1-1"
              @click="$router.push({ path: '/objects/add' })">
              Депонировать объект
            </el-menu-item>

            <el-menu-item
              index="1-2"
              @click="$store.commit('theme/setCurTheme', 'theme-b')"
              v-if="curTheme === 'theme-w'">
              Темное оформление
            </el-menu-item>

            <el-menu-item
              index="1-3"
              @click="$store.commit('theme/setCurTheme', 'theme-w');"
              v-if="curTheme === 'theme-b'">
              Светлое оформление
            </el-menu-item>

            <el-submenu index="2">

              <template slot="title">О проекте</template>

              <el-menu-item
                index="2-1"
                @click="$router.push({ path: '/about-project' })">
                О проекте
              </el-menu-item>

              <el-menu-item
                index="2-2"
                @click="$router.push({ path: '/about-ois' })">
                Цифровые объекты авторского права (ЦОАП)
              </el-menu-item>

              <el-menu-item
                index="2-3"
                @click="$router.push({ path: '/help/1' })">
                Справочная информация
              </el-menu-item>

              <el-menu-item
                index="2-4"
                @click="$router.push({ path: '/about-team' })">
                Команда проекта
              </el-menu-item>

              <el-menu-item
                index="2-5"
                @click="$router.push({ path: '/about-organizations' })">
                Вузы-участники проекта
              </el-menu-item>

              <!--<el-menu-item
                index="2-6"
                @click="$router.push({ path: '/about-mentors' })">
                Менторы
              </el-menu-item>-->

            </el-submenu>

            <el-menu-item
              index="1-6"
              @click="$store.commit('setTourState', 1)">
              Виртуальный тур
            </el-menu-item>

            <el-menu-item
              index="1-4"
              @click="$router.push({ path: '/user/objects' })">
              <template v-if="isAuthenticated">
                Личный кабинет
              </template>
              <template v-else>
                Войти
              </template>
            </el-menu-item>

            <el-menu-item
              index="1-5"
              @click="$store.dispatch('user/logout')"
              v-if="isAuthenticated">
              Выход
            </el-menu-item>

          </el-submenu>
        </el-menu>

      </div>

    </div>
  </nav>
</template>

<script>
/* eslint-disable default-case */
import axios from 'axios';
import { TweenMax, Power1 } from 'gsap/TweenMax';
import ThemeSelector from './ThemeSelector';

export default {

  components: { ThemeSelector },

  data() {
    return {
      showThemeSelector: false,
      userData: 0,
      userGameStatus: {
        userScore: null,
        userReputation: null,
        userPrevScore: null,
        userPrevReputation: null,
      },
    };
  },

  created() {
    this.loadUserData();
  },

  mounted() {
    this.setShowThemeSelector();
    window.addEventListener('resize', this.setShowThemeSelector);
  },

  computed: {

    userScoreTrend() {
      if (this.isAuthenticated &&
        this.userGameStatus.userScore &&
        this.userGameStatus.userPrevScore) {
        return this.userGameStatus.userScore - this.userGameStatus.userPrevScore;
      }
      return '';
    },

    userReputationTrend() {
      if (this.isAuthenticated &&
        this.userGameStatus.userReputation &&
        this.userGameStatus.userPrevReputation) {
        return this.userGameStatus.userReputation - this.userGameStatus.userPrevReputation;
      }
      return '';
    },

    isAuthenticated() {
      return this.$store.getters['user/isAuthenticated'];
    },

    userFio() {
      let sn = '';
      if (this.isAuthenticated && this.userData) {
        sn = `${this.userData.Surname} ${this.userData.Name}`;
      }
      return sn;
    },

  },

  watch: {
    $route() {
      this.setShowThemeSelector();
      this.loadUserGameStatus();
    },

    isAuthenticated() {
      this.loadUserData();
    },
  },

  methods: {

    loadUserGameStatus() {
      if (this.userData && this.userData.UserId) {
        axios.get(`/users/${this.userData.UserId}/gamestatus`).then((r) => {
          this.userGameStatus.userScore = r.data.Score;
          this.userGameStatus.userReputation = r.data.Reputation;
          if (this.userGameStatus.userPrevScore === null ||
            this.userGameStatus.userPrevReputation === null) {
            axios.post('/users/prevgamestatus').then((prevStatus) => {
              this.userGameStatus.userPrevScore = prevStatus.data.score;
              this.userGameStatus.userPrevReputation = prevStatus.data.reputation;
            }).catch(() => {});
          }
        }).catch(() => {});
      }
    },

    loadUserData() {
      const userId = this.$store.getters['user/getUserId'];
      if (userId) {
        axios.get(`users/${userId}`).then((r) => {
          this.userData = r.data;
          this.loadUserGameStatus();
        }).catch(() => {});
      }
    },

    setShowThemeSelector() {
      this.showThemeSelector = window.innerWidth < 1270
        || (['/', '/by-types', '/objects/search'].indexOf(this.$route.path) === -1
          && this.$route.path.search('/by-org/') !== 0);
    },

    animateLogo() {
      const symbol = this.$el.querySelector('.lgo_symbol');
      if (!TweenMax.isTweening(symbol)) {
        TweenMax.fromTo(symbol, 1,
          { rotationY: 0 },
          { rotationY: 360, ease: Power1.easeInOut },
        );
      }
    },

    aboutProjectMenuHandler(command) {
      this.$router.push({ path: command });
    },

    mobileMenuHandler() {
      this.$refs.mobileMenu.close('1');
    },

    userIconClicked() {
      if (this.isAuthenticated) {
        this.$router.push({ path: '/user/objects' });
      } else {
        this.$router.push({ path: '/user/authenticate' });
      }
    },

    userStatClicked() {
      if (this.userScoreTrend !== 0 || this.userReputationTrend !== 0) {
        const userStatus = {};
        userStatus.score = this.userGameStatus.userScore;
        userStatus.reputation = this.userGameStatus.userReputation;
        axios.put('/users/prevgamestatus', JSON.stringify(userStatus)).then(() => {
          this.userGameStatus.userPrevScore = this.userGameStatus.userScore;
          this.userGameStatus.userPrevReputation = this.userGameStatus.userReputation;
        }).catch(() => {
        });
      }
      this.$router.push({ path: '/user/profile' });
    },

  },

};
</script>

<style lang="scss">
@import "../styles/common/main";

.nav-top_ntp {
  @include box-shadow(0 2px 10px rgba(0, 0, 0, .1));

  .attention-test {
    color: #fff;
    text-align: center;
    background-color: #bd4e9b;
    font-size: 12px;
    line-height: 24px;
  }

  .ntp_container {
    height: 90px;
    max-width: 1790px;
    padding: 25px 15px 0;
    position: relative;
    margin: 0 auto;
  }

  .ntp_logo_lgo {
    width: 120px;
    height: 40px;
    display: block;
    float: left;
    cursor: pointer;
    .lgo_symbol {
      width: 40px;
      height: 40px;
      display: block;
      float: left;
      background: 50% 50% no-repeat url(../../static/grx/logo/symbol.png);
      background-size: contain;
    }
    .lgo_text {
      width: 80px;
      height: 40px;
      display: block;
      float: left;
      @extend .img-sharp;
    }
  }

  .menu_ntm {
    float: right;
    padding-right: 10px;
    overflow: visible;
    .ntm_icon {
      cursor: pointer;
      width: 40px;
      height: 40px;
      display: inline-block;
      vertical-align: top;
      @include transition;
      overflow: visible;
      &:hover {
        // @include transform(scale(1.1));
        @include opacity(.7);
      }
      &.ntm_icon--user-fio {
        text-overflow: ellipsis;
        font-size: 12px;
        line-height: 13px;
        text-align: center;
        display: inline-block;
        vertical-align: top;
        width: auto;
        max-width: 80px;
        background: none !important;
        position: relative;
        padding-top: 22px;
        overflow: visible;
        height: 50px;
        &:before {
          content: '';
          background: 50% 50% no-repeat url(../../static/grx/icons/person-w.svg);
          background-size: contain;
          width: 30px;
          height: 30px;
          position: absolute;
          left: 50%;
          top: -9px;
          margin: 0 0 0 -15px;
        }
      }
      &.ntm_icon--user_stat {
        padding-left: 5px;
        width: auto;
        text-align: left;
        .user-score,
        .user-reputation {
          .user-stat-trend {
            vertical-align: top;
            &.trend-neg {
              color:#d6757d;
            }
            &.trend-pos {
              color:#1aa69d;
            }
          }
          &:before {
            vertical-align: text-top;
            display: inline-block;
            content: '';
            width: 15px;
            height: 15px;
          }
        }
        .user-score {
          &:before {
            background: 0 0 no-repeat url(../../static/grx/icons/game-score.svg);
          }
        }
        .user-reputation {
          &:before {
            background: 0 0 no-repeat url(../../static/grx/icons/game-reputation.svg);
          }
        }
      }
    }
    .ntm_divider {
      width: 2px;
      height: 40px;
      display: inline-block;
      vertical-align: top;
      margin: 0 30px;
    }
    .ntm_link {
      height: 40px;
      padding-top: 5px;
      font-size: 14px;
      display: inline-block;
      vertical-align: top;
      text-transform: uppercase;
      cursor: pointer;
      @include transition;
    }
    .ntm_dropdown {
      vertical-align: top;
      .ntm_link {
        cursor: default;
      }
    }
  }

  .ntp_menu-mobile_mme {
    display: none;
    float: right;
    .mme_trigger {
      width: 40px;
      height: 40px;
      background: 50% 50% no-repeat;
      background-size: contain;
    }
    .mme_menu {
      z-index: 5;
      position: absolute;
      border-right: none;
      background-color: transparent !important;
      right: 10px;
      top: 25px;
      .mme_trigger {
        float: right;
      }
      .el-submenu__title:hover {
        background-color: transparent;
      }
      > li > div > .el-submenu__icon-arrow {
        display: none;
      }
      > li > .el-menu {
        min-width: 250px;
        box-shadow: 0 2px 20px rgba(0, 0, 0, .25);
        border-radius: 10px;
        overflow: hidden;
        position: absolute;
        right: 0;
        top: 50px;
        > li > .el-submenu__title {
          line-height: 34px;
          height: 34px;
        }
        > li:first-of-type {
          margin-top: 14px;
        }
        > li:last-of-type {
          margin-bottom: 14px;
        }
      }
      .el-menu-item {
        white-space: normal;
        line-height: 18px;
        height: auto;
        padding-top: 8px;
        padding-bottom: 8px;
        &.is-active,
        &:hover,
        &:focus {
          color: #303133 !important;
          background: transparent;
        }
      }
      .el-submenu {
        .el-submenu__title {
          height: auto;
        }
        .el-submenu__title,
        .el-menu-item {
          padding-left: 20px !important;
          padding-right: 20px;
        }
        .el-submenu .el-menu-item {
          padding-left: 35px !important;
        }
      }
    }
  }

  @media (max-width: 900px) {
    .menu_ntm {
      display: none;
    }
    .ntp_menu-mobile_mme {
      display: block;
    }
  }

  // Black theme
  &.theme-b {
    background: $bg-theme-b;

    .ntp_logo_lgo {
      .lgo_text {
        background: 50% 50% no-repeat url(../../static/grx/logo/text-w.png);
        background-size: contain;
      }
    }

    .menu_ntm {
      .ntm_divider {
        background: #242424;
      }
      .ntm_link {
        color: #bdbdbd;
        line-height: normal;
        &:hover {
          color: #fff;
        }
      }
      .ntm_icon {
        &.ntm_icon--depo {
          background: 50% 50% no-repeat url(../../static/grx/icons/add-w.svg);
        }
        &.ntm_icon--tour {
          background: 50% 50% no-repeat url(../../static/grx/icons/tour-w.svg);
        }
        &.ntm_icon--user {
          background: 50% 50% no-repeat url(../../static/grx/icons/person-w.svg);
        }
        &.ntm_icon--exit {
          background: 50% 50% no-repeat url(../../static/grx/icons/exit-w.svg);
        }
        &.ntm_icon--user-fio {
          color: #fff;
          &:before {
            background: 50% 50% no-repeat url(../../static/grx/icons/person-w.svg);
          }
        }
        &.ntm_icon--user_stat {
          color: #fff;
        }
      }
    }

    .ntp_menu-mobile_mme {
      .mme_trigger {
        background-image: url(../../static/grx/icons/menu-w.svg);
      }
    }

  }

  // White theme
  &.theme-w {
    background: $bg-theme-w;

    .ntp_logo_lgo {
      .lgo_text {
        background: 50% 50% no-repeat url(../../static/grx/logo/text-b.png);
        background-size: contain;
      }
    }

    .menu_ntm {
      .ntm_divider {
        background: #ececec;
      }
      .ntm_link {
        color: #666;
        &:hover {
          color: #000;
        }
      }
      .ntm_icon {
        &.ntm_icon--depo {
          background: 50% 50% no-repeat url(../../static/grx/icons/add-b.svg);
        }
        &.ntm_icon--tour {
          background: 50% 50% no-repeat url(../../static/grx/icons/tour-b.svg);
        }
        &.ntm_icon--user {
          background: 50% 50% no-repeat url(../../static/grx/icons/person-b.svg);
        }
        &.ntm_icon--exit {
          background: 50% 50% no-repeat url(../../static/grx/icons/exit-b.svg);
        }
        &.ntm_icon--user-fio {
          color: #000;
          &:before {
            background: 50% 50% no-repeat url(../../static/grx/icons/person-b.svg);
          }
        }
      }
    }

    .ntp_menu-mobile_mme {
      .mme_trigger {
        background-image: url(../../static/grx/icons/menu-b.svg);
      }
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/components/NavTop.vue